<template x-mlns="http://www.w3.org/1999/html">
    <!--  <div>索康</div>-->
    <div>
        <header-img :headImg="main"></header-img>
        <div class="main-JS" :style="main==null?{}:{backgroundImage:'url('+main.homePage.backgroundImage+')'}" >
            <div ref="JSdiv"></div>
            <div>
                <div class="main-JS-content">
                    <div class="main-JS-content-img">
                        <div class="main-JS-content-img-div mianPImg-box">
                            <img class="main-JS-img" src="../../static/image/main/mainMS.jpg" alt="使用索康曼殊的模特图" v-if="main==null">
                            <img class="main-JS-img" :src="main.ManShu.homePageImage" alt="使用索康曼殊的模特图" v-else>
                            <div class="mianPImg-boxs">
                                <span class="mainPImg"></span>
                                <router-link :to="{path:'/product/manshu'}">
                                    <img class="mainPText" src="../../static/image/main/mainNext.png">
                                </router-link>
                            </div>
                        </div>
                        <div class="main-JS-content-img-div mianPImg-box">
                            <img class="main-JS-img" src="../../static/image/main/mainLX.jpg" alt="使用索康立秀的模特图" v-if="main==null">
                            <img class="main-JS-img" :src="main.LiXiu.homePageImage" alt="使用索康曼殊的模特图" v-else>
                            <div class="mianPImg-boxs">
                                <span class="mainPImg"></span>
                                <router-link :to="{path:'/product/lixiu'}">
                                    <img class="mainPText" src="../../static/image/main/mainNext.png">
                                </router-link>
                            </div>
                        </div>
                        <div class="main-JS-content-img-div mianPImg-box">
                            <img class="main-JS-img" src="../../static/image/main/mainAN.png" alt="使用索康ainose的模特图" v-if="main==null">
                            <img class="main-JS-img" :src="main.AINOSE.homePageImage" alt="使用索康曼殊的模特图" v-else>
                            <div class="mianPImg-boxs">
                                <span class="mainPImg" style="font-family: Futura-LT-Light"></span>
                                <router-link :to="{path:'/product/ainose'}">
                                    <img class="mainPText" src="../../static/image/main/mainNext.png">
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main-box">
            <!--      <div :class="[ Proportion > 0.7? 'main-plastic-text': 'main-plastic-text-min','main-plastic'] ">整&nbsp&nbsp形&nbsp&nbsp外&nbsp&nbsp科</div>-->
            <div class="main-plastic-text main-plastic">整&nbsp&nbsp形&nbsp&nbsp外&nbsp&nbsp科</div>
            <div class="main-JS-content-img">
                <div class="main-img-div">
                    <img class="main-JS-img" src="../../static/image/GIF/prosthesis.gif" v-if="main==null">
                    <img class="main-JS-img" :src="main.ManShu.homePageGif" v-else>
                    <!--          <div :class="[ Proportion > 0.7? 'main-img-div-text': 'main-img-div-text-min'] ">Mandibular plastic<br> surgery</div>-->
                    <!--                    <div class="main-img-div-text ">Mandibular plastic<br> surgery</div>-->
                    <!--                    <router-link :to="{path:'/product/manshu'}">-->
                    <!--                        <div class="main-img-div-text ">-->
                    <!--                            <img class="main-LJ" src="../../static/image/main/mainLJ.png">-->
                    <!--                        </div>-->
                    <!--                    </router-link>-->
                </div>
                <div class="main-img-div">
                    <img class="main-JS-img" src="../../static/image/GIF/chin.gif" v-if="main==null">
                    <img class="main-JS-img" :src="main.LiXiu.homePageGif" v-else>
                    <!--          <div :class="[ Proportion > 0.7? 'main-img-div-text': 'main-img-div-text-min'] ">Facial prosthesis<br> implants</div>-->
                    <!--                    <div class="main-img-div-text">Facial prosthesis<br> implants</div>-->
                    <!--                    <router-link :to="{path:'/product/lixiu'}">-->
                    <!--                        <div class="main-img-div-text ">-->
                    <!--                            <img class="main-LJ" src="../../static/image/main/mainLJ.png">-->
                    <!--                        </div>-->
                    <!--                    </router-link>-->
                </div>
                <div class="main-img-div">
                    <img class="main-JS-img" src="../../static/image/GIF/nose.gif" v-if="main==null">
                    <img class="main-JS-img" :src="main.AINOSE.homePageGif" v-else>
                    <!--          <div :class="[ Proportion > 0.7? 'main-img-div-text': 'main-img-div-text-min'] ">Nasal prosthesis<br> implant</div>-->
                    <!--                    <div class="main-img-div-text">Nasal prosthesis<br> implant</div>-->
                    <!--                    <router-link :to="{path:'/product/ainose'}">-->
                    <!--                        <div class="main-img-div-text ">-->
                    <!--                            <img class="main-LJ" src="../../static/image/main/mainLJ.png">-->
                    <!--                        </div>-->
                    <!--                    </router-link>-->
                </div>
            </div>
        </div>
        <!--        <div class="progressive">-->
        <!--            <img class="preview" v-progressive="mainB02" :src="mainB02M"/>-->
        <!--        </div>-->
        <div>
            <img class="main-JS-img" src="../../static/image/main/mainB02.jpeg" v-if="main==null">
            <img class="main-JS-img" :src="main.homePage.sliceImage" v-else>
        </div>
        <pagination :enter="main"></pagination>
        <!--        <div class="progressive">-->
        <!--            <img class="preview" v-progressive="mainB03" :src="mainB03M"/>-->
        <!--        </div>-->
        <!--        <div><img class="main-JS-img" src="../../static/image/main/mainB03.png"></div>-->
        <div class="main-box">
            <!--      <el-row>-->
            <!--        <el-col type="flex" align="center" :span="10"  :offset="4">-->
            <!--          <img class="main-JS-img" src="../../static/image/main/mainC01.png">-->
            <!--        </el-col>-->
            <!--        <el-col type="flex" align="center" justify="center" :span="6">-->
            <!--          <div class="case-div-text">-->
            <!--            <img class="main-JS-img" src="../../static/image/main/mainP6.png">-->
            <!--            <div class="case-div-text-T">PIRIFORM FORAMEN IMPLANT</div>-->
            <!--            <div class="case-div-text-D"> Scientific plastic surgery is more secure than anything else</div>-->
            <!--          </div>-->
            <!--        </el-col>-->
            <!--      </el-row>-->
            <!--            <router-link :to="{path:'/case',query:{id:'1'}}">-->
            <!--                <img class="main-JS-img" src="../../static/image/main/mainD01.jpg" alt="使用索康的案例">-->
            <!--            </router-link>-->
            <!--            <div class="case-separate-div">-->
            <!--                <el-row>-->
            <!--                    <el-col :xs="16" :sm="16" :md="16" :lg="9" :xl="9" :offset="4">-->
            <!--                        <div class="case-separate-T">她们变美的故事</div>-->
            <!--                    </el-col>-->
            <!--                </el-row>-->
            <!--                <el-row>-->
            <!--                    <el-col :xs="16" :sm="16" :md="16" :lg="9" :xl="9" :offset="4">-->
            <!--                        <div class="case-separate-D">Change is not only the appearance, but also the life</div>-->
            <!--                    </el-col>-->
            <!--                </el-row>-->
            <!--            </div>-->
            <!--      <el-row>-->
            <!--        <el-col type="flex" align="center" justify="center"-->
            <!--                :span="6"  :offset="6" >-->
            <!--          <div class="case-div-text">-->
            <!--            <img class="main-JS-img" src="../../static/image/main/mainP7.png">-->
            <!--            <div class="case-div-text-T">PIRIFORM FORAMEN IMPLANT</div>-->
            <!--            <div class="case-div-text-D"> Scientific plastic surgery is more secure than anything else</div>-->
            <!--          </div>-->
            <!--        </el-col>-->
            <!--        <el-col type="flex" align="center"-->
            <!--                :span="6" :offset="2">-->
            <!--          <img class="main-JS-img" src="../../static/image/main/mainC02.png">-->
            <!--        </el-col>-->
            <!--      </el-row>-->
            <!--            <router-link :to="{path:'/case',query:{id:'2'}}">-->
            <!--                <img class="main-JS-img" src="../../static/image/main/mainD02.jpg" alt="使用索康的案例">-->
            <!--            </router-link>-->

            <!--            <div class="case-separate-div">-->
            <!--                <el-row>-->
            <!--                    <el-col :span="16" :offset="4">-->
            <!--                        <div class="case-separate-T">一样的变美，不一样的感受</div>-->
            <!--                        <div class="case-separate-D" style="margin-bottom: 30px">Beautify with extraordinary experience</div>-->
            <!--                    </el-col>-->
            <!--                </el-row>-->
            <!--&lt;!&ndash;                <router-link :to="{path:'/case',query:{id:'3'}}">&ndash;&gt;-->
            <!--                    <img class="main-JS-img" src="../../static/image/main/mainD03.jpg" alt="使用索康的案例">-->
            <!--&lt;!&ndash;                </router-link>&ndash;&gt;-->
            <!--                &lt;!&ndash;        <el-row >&ndash;&gt;-->
            <!--                &lt;!&ndash;          <el-col :span="16" :offset="4">&ndash;&gt;-->
            <!--                &lt;!&ndash;            <div class="case-separate-D">&ndash;&gt;-->
            <!--                &lt;!&ndash;              Expanded polytetrafluoroethylene (PTFE) facial plastic materials were introduced from the United States.<br>&ndash;&gt;-->
            <!--                &lt;!&ndash;              Through the technical improvement of domestic R&D team, the limitation that PTFE products<br>&ndash;&gt;-->
            <!--                &lt;!&ndash;              can not be shaped was broken through&ndash;&gt;-->
            <!--                &lt;!&ndash;            </div>&ndash;&gt;-->
            <!--                &lt;!&ndash;          </el-col>&ndash;&gt;-->
            <!--                &lt;!&ndash;        </el-row>&ndash;&gt;-->
            <!--                &lt;!&ndash;      </div>&ndash;&gt;-->
            <!--                &lt;!&ndash;      <div class="main-JS-content-img">&ndash;&gt;-->
            <!--                &lt;!&ndash;        <div class="main-img-div">&ndash;&gt;-->
            <!--                &lt;!&ndash;          <img class="main-JS-img" src="../../static/image/main/mainBoon1.png">&ndash;&gt;-->
            <!--                &lt;!&ndash;        </div>&ndash;&gt;-->
            <!--                &lt;!&ndash;        <div class="main-img-div">&ndash;&gt;-->
            <!--                &lt;!&ndash;          <img class="main-JS-img" src="../../static/image/main/mainBoon2.png">&ndash;&gt;-->
            <!--                &lt;!&ndash;        </div>&ndash;&gt;-->
            <!--                &lt;!&ndash;        <div class="main-img-div">&ndash;&gt;-->
            <!--                &lt;!&ndash;          <img class="main-JS-img" src="../../static/image/main/mainBoon3.png">&ndash;&gt;-->
            <!--                &lt;!&ndash;        </div>&ndash;&gt;-->
            <!--            </div>-->
        </div>
        <news-div></news-div>
    </div>
</template>
<script>
import headerImg from './components/HeaderImg'
import pagination from './components/Pagination'
import newsDiv from './components/news'

import mainB02 from "../../static/image/main/mainB02.jpeg"
// import mainB02M from "../../static/image/main/mainB02-min.png"
import mainB03 from "../../static/image/main/mainB03.png"
import mainB03M from "../../static/image/main/mainB03-min.png"

export default {
  name: 'Main',
  metaInfo: {
    title: '索康', // set a title
    meta: [{                 // set meta
      name: 'keyWords',
      content: '索康'
    }],
    link: [{                 // set link
      rel: 'description',
      content: '这是索康的官网的首页'
    }]
  },
  components: {headerImg, pagination, newsDiv},
  data() {
    return {
      Proportion: document.body.clientWidth / document.body.clientHeight,
      newsDiv: '',
      mainB02: mainB02,
      // mainB02M: mainB02M,
      mainB03: mainB03,
      mainB03M: mainB03M,
      main: null
    }
  },
  created() {
    this.$store.dispatch('main/mainMessage').then((res) => {
      this.main = res
      // console.log(res)
    })
  },
  mounted() {
    // this.$refs.JSdiv.style.height = (document.body.clientWidth / 3.8) + 'px'
    //
    // if (this.Proportion > 0.6) {
    //   this.newsDiv = (document.body.clientWidth / 12) + 'px'
    // } else {
    //   this.newsDiv = '55px'
    // }
    // console.log(this.newsDiv)
  }
}
</script>

<style scoped>
    .main-JS {
        /*background-image: url('../../static/image/main/mainB01.jpg');*/
        background-size: 100% 100%;
        height: 750px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }

    .main-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
    }

    .main-JS-content {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
        margin-bottom: 30px;
    }

    .main-JS-content-img-div {
        width: 33.3%;
    }

    .main-img-div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        width: 33%;
        font-family: Futura-LT-Light;
        /*font-size: 18px;*/
        text-align: center;
    }

    .main-JS-img {
        width: 100%;
        height: auto;
    }

    .main-JS-content-img {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        background-color: white;
        width: 70%;
        padding: 10px;
        color: #4d4d4d;
    }

    .main-plastic {
        color: #430098;
        font-family: SY-Normal;
    }

    .main-plastic-text {
        font-size: 41px;
        margin: 50px 0 80px 0;
    }

    .main-img-div-text {
        /*font-size: 20px;*/
        margin: 30px 0;
    }

    .case-div-text {
        padding: 0 15%;
    }

    .case-div-text-T {
        /*font-size: 18px;*/
        font-family: Futura-LT-Book;
        color: #4d4d4d;
        margin-bottom: 8%;
    }

    .case-div-text-D {
        /*font-size: 18px;*/
        font-family: Futura-LT-Light;
        color: #4d4d4d;
    }

    .case-separate-div {
        width: 100%;
        margin: 30px 0;
    }

    .case-separate-T {
        font-size: 28px;
        font-family: SY-Light;
        color: #430098;
        text-align: center;
        margin-bottom: 10px;
    }

    .case-separate-D {
        /*font-size: 18px;*/
        font-family: Futura-LT-Light;
        color: #4d4d4d;
        text-align: center;
    }

    .mianPImg-boxs {
        position: absolute;
        bottom: 25px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center
    }

    .mainPImg {
        color: white;
        font-size: 25px;
        font-family: SY-Light;
        margin-left: 30px
    }

    .mainPText {
        width: 30px;
        margin-right: 30px
    }

    .mianPImg-box {
        position: relative;
    }

    .main-LJ {
        width: 100px;
    }
</style>
